/**
 * Persistent Navigation Utility
 * 
 * This utility helps maintain the intended URL during auth/access redirects
 * by storing and retrieving the intended destination in session storage.
 */

// Storage key
const INTENDED_URL_KEY = 'cellcog_intended_url';

/**
 * Save the current URL as the intended destination
 * @param {string} url - The URL to save (defaults to current location)
 */
export const saveIntendedUrl = (url = window.location.pathname) => {
  // Only save if it's not an auth or access page
  if (!url.startsWith('/login') && 
      !url.startsWith('/signup') && 
      !url.startsWith('/waitlist')) {
    sessionStorage.setItem(INTENDED_URL_KEY, url);
  }
};

/**
 * Get and clear the intended URL
 * @returns {string|null} The intended URL or null if none was saved
 */
export const getAndClearIntendedUrl = () => {
  const url = sessionStorage.getItem(INTENDED_URL_KEY);
  sessionStorage.removeItem(INTENDED_URL_KEY);
  return url;
};

/**
 * Check if there is an intended URL saved
 * @returns {boolean} True if there is an intended URL
 */
export const hasIntendedUrl = () => {
  return !!sessionStorage.getItem(INTENDED_URL_KEY);
};
